import { createSelector } from 'reselect';
import { getPageData, getPageFeatureFlags } from 'src/universal/redux/page';

export const getAlertBannerData = createSelector(
  [getPageData, getPageFeatureFlags],
  ({ alertBanner = {} }, { hideAlertBanner = false }) => ({
    primaryHeadline: alertBanner.title,
    secondaryHeadline: alertBanner.subTitle,
    shouldRender: !hideAlertBanner && !!alertBanner.subTitle
  })
);
